import { z } from "zod";
export const ResetUserPassword = z.object({
    email: z.string().email(),
    token: z.string(),
    newPassword: z.string().min(8).max(128),
});
//# sourceMappingURL=user-reset-password.js.map